// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import utils from './util'
import iView from 'iview';

// 重置theme
import './assets/common/index.less'

// 图标字体库
import './assets/iconfont/iconfont.css'

//import echarts from 'echarts'

// 挂载
Vue.use(iView);


//Vue.prototype.$echarts = echarts;

// 定义方法
Vue.prototype.utils = utils;

// 配置跨域
Vue.prototype.$axios = axios.create({
   baseURL: ''
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js